/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_KeineprferenzInputs */

const en__field_enum_keineprferenz = /** @type {(inputs: _Field_Enum_KeineprferenzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no preference`)
};

const de__field_enum_keineprferenz = /** @type {(inputs: _Field_Enum_KeineprferenzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keine Präferenz`)
};

/**
* | output |
* | --- |
* | "no preference" |
*
* @param {_Field_Enum_KeineprferenzInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_enum_keineprferenz = /** @type {((inputs?: _Field_Enum_KeineprferenzInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_KeineprferenzInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_keineprferenz(inputs)
	return de__field_enum_keineprferenz(inputs)
});